import { useTranslation } from 'react-i18next'
import { Modal } from './modal'
import { Button } from './button'

interface ConfirmDeleteDialogProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
  isPending: boolean
  itemName: string
  /** Overrides the default "Confirm Delete" heading. */
  title?: string
  /** Overrides the default "Are you sure you want to delete {itemName}?" body. */
  message?: string
  /** Overrides the default "Delete" label on the confirm button. */
  confirmLabel?: string
  /** Extra line shown under the message. */
  detail?: string
}

export function ConfirmDeleteDialog({
  isOpen,
  onConfirm,
  onCancel,
  isPending,
  itemName,
  title,
  message,
  confirmLabel,
  detail,
}: ConfirmDeleteDialogProps) {
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={isOpen}
      onClose={isPending ? () => {} : onCancel}
      title={title ?? t('deleteConfirmation.title')}
      size="sm"
    >
      <p className="text-sm text-text-secondary">
        {message ?? t('deleteConfirmation.message', { itemName })}
      </p>
      {detail ? <p className="mt-2 text-sm text-text-secondary">{detail}</p> : null}
      <div className="mt-6 flex justify-end gap-3">
        <Button variant="secondary" onClick={onCancel} disabled={isPending}>
          {t('common.cancel')}
        </Button>
        <Button variant="danger" onClick={onConfirm} isLoading={isPending}>
          {confirmLabel ?? t('common.delete')}
        </Button>
      </div>
    </Modal>
  )
}
